module.exports = __webpack_public_path__ + "70ba0ce7fa5edfcac4b24dd7ec76d5fc.svg";